export const ORG_CHART_HR_NAME = 'orgChartHrName';
export const ORG_CHART_HR_SOFTWARE_ID = 'orgChartHrSoftwareId';
export const AGENT_FIRST_NAME = 'agentFirstName';
export const AGENT_LAST_NAME = 'agentLastName';
export const AGENT_SOFTWARE_ID = 'agentSoftwareId';
export const JOB_LABEL = 'jobLabel';
export const JOB_NUMBER = 'jobNumber';
export const ACCOUNTABLE_STANDARD_CODE = 'natureCode';
export const POSITION_LABEL = 'positionLabel';
export const PERMANENT = 'permanent';
export const NON_PERMANENT = 'nonPermanent';
export const POSITION_ADMIN = 'positionAdmin';
export const ABSENCE_REASON = 'absenceReason';
export const ECHELON_FIELD = 'echelon';
export const ECHELON_GRADE = 'echelonGrade';
export const ECHELON_FILIERE = 'echelonFiliere';
export const ECHELON_SENIORITY = 'echelonSeniority';
export const ECHELON_DURATION = 'echelonDuration';
export const POSITION_NUMBER = 'positionNumber';
export const VACANT_POSITION_LABEL = 'vacantPositionLabel';
export const VACANT_POSITION_NUMBER = 'vacantPositionNumber';
export const VACANT_POSITION_START_DATE = 'vacantPositionStartDate';
export const VACANT_POSITION_END_DATE = 'vacantPositionEndDate';
export const SOFTWARE_RETIREMENT_SYSTEM = 'softwareRetirementSystem';
export const CONTRACT_TYPE = 'contractType';

export const DATE_FIELD = 'ventilatedDate';
export const SALARY = 'salary';
export const IFSE = 'ifse';
export const SALARY_RAW_CHARGED_FIELD = 'salaryValue';
export const ETP = 'etp';
export const ETP_FIELD = 'etpValue';
export const HOURS_FIELD = 'hoursCount';
export const EXTRA_HOURS_COST = 'extraHoursCost';
export const EXTRA_HOURS_COUNT = 'extraHoursCount';
export const COMP_HOURS_COST = 'compHoursCost';
export const COMP_HOURS_COUNT = 'compHoursCount';
export const ASTREINTE_HOURS_COST = 'astreinteHoursCost';
export const TOTAL_HOURS_COST = 'totalHoursCost';
export const TOTAL_HOURS_COUNT = 'totalHoursCount';
export const ABSENCE_COST = 'absenceCost';
export const ABSENCE_COUNT = 'absenceCount';
export const PRIMES_COSTS = 'primesCost';

export const POSITION_STATUTAIRE = 'positionStatutaire';
export const QUALITE_EMPLOI = 'qualiteEmploi';
export const ORG_CHART_HR_MAPPING = 'orgChartHrMapping';
export const RECURRENCE = 'recurrence';
export const INDICIAIRE = 'indiciaire';
export const MANTY_STATUS = 'mantyStatus';
export const RETIREMENT_SYSTEM = 'retirementSystem';

export const NEW_VALUES_BY_DATES = 'newValuesByDates';
export const COMMENT = 'comment';

export const GRADE = 'grade';
export const ECHELON = 'echelon';
